<template>

  <!--========================================


  ---------------------------------------------
  TABLE_OF_CONTENTS_OF_HTML_TEMPLATE
  ---------------------------------------------
  1. HEADER_SECTION
  2. AGREEMENT_SECTION
  2.1 FILTERS_SECTION
  3. INVOICES_SECTION
  4. MODALS_SECTION
  5. TIMELINE_SECTION 
  ---------------------------------------------




  ---------------------------------------------
  TABLE_OF_CONTENTS_OF_JS_SCRIPT
  ---------------------------------------------
  1. PRIMARY_DATA
  2. SETTERS_AND_GETTERS
  3. CALCULATE_SUM_WATCHERS
  4. PRIMARY_INITIALIZATION
  5. VIEW_AND_EDIT_MODES
  6. REFRESH_TIMELINE
  7. REFRESH
  8. CALCULATE_SUM
  9. DISABLE_STATUS_IF_NEEDED
  10. SHOW_MODALS
  11. OTHERS
  ---------------------------------------------



  ========================================-->

  <div>
    <div>
      <b-card>
        <b-row class="align-items-center">


          <!--  ==============================  HEADER_SECTION START ============================== -->
          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">
                {{ $t("application_number") }}
              </h6>
              <small>#{{ GET_ONE_CONTRACT.id }}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">
                {{ $t("date") }}
              </h6>
              <small>{{$dayjs(GET_ONE_CONTRACT.created_at).format("DD.MM.YYYY")}}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">
                {{ $t("author") }}
              </h6>
              <div class="d-flex">
                <small
                  v-if="
                    GET_ONE_CONTRACT.author &&
                    GET_ONE_CONTRACT.author.first_name
                  "
                  >{{ GET_ONE_CONTRACT.author.first_name }}</small
                >
                <small v-if="GET_ONE_CONTRACT.author" class="ml-50">{{
                  GET_ONE_CONTRACT.author.last_name
                }}</small>
              </div>
            </div>
          </b-col>

          <b-col class="col-md-3">
            <div class="flex_column align-items-center">
              <h6 class="font-weight-bolder">
                {{ $t("status") }}
              </h6>
              <b-badge
                v-if="GET_ONE_CONTRACT.status"
                :variant="GET_ONE_CONTRACT.status.color"
              >
                {{ GET_ONE_CONTRACT.status.name }}
              </b-badge>
            </div>
          </b-col>

          <b-col v-if="GET_ONE_CONTRACT.status" class="col-md-3">
            <div
              class="d-flex flex-wrap justify-content-end align-items-center"
            >
              <template
                v-for="(item, index) in GET_ONE_CONTRACT.status.change_to"
              >
                <b-button
                  v-if="checkButtonPermission([...item.roles, 'admin'])"
                  :key="index"
                  size="sm"
                  class="ml-50"
                  style="margin: 3px 0"
                  :variant="item.color"
                  :disabled="disableStatusIfNeeded()"
                  @click="onChangeStatus(GET_ONE_CONTRACT, item)"
                >
                  <!-- :disabled="checkAndDisableStatusIfNeeded(item)" -->
                  {{ item.name }}
                </b-button>
              </template>
            </div>
          </b-col>
          <!--  ==============================  HEADER_SECTION END ============================== -->




        </b-row>
      </b-card>
      <b-row>
        <b-col>
          <b-card>
            <validation-observer ref="contractValidations">
              <b-tabs>







                <!--  ==============================  AGREEMENT_SECTION START ============================== -->
                <b-tab active :title="$t('agreement')">
                  <div class="top">
                    <div
                      class="d-flex align-items-center justify-content-between flex-wrap"
                    >
                      <div class="d-flex">



                        
                        <!--  ==============================  FILTERS_SECTION START ============================== -->
                        <b-form-group :label="$t('agreement')">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('agreement')"
                            rules="required"
                          >
                            <b-form-input
                              v-model="contract.contract_number"
                              :placeholder="$t('agreement')"
                              :disabled="viewMode"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group :label="$t('date')" class="ml-1">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('date')"
                            rules="required"
                          >
                            <VueDataPicker
                              class="date-dark"
                              v-model="contract.date"
                              placeholder="YYYY-MM-DD"
                              :disabled="viewMode"
                              :readonly="viewMode"
                              :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>


                        <b-form-group :label="$t('provider')" class="ml-1 mr-1">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('provider')"
                            rules="required"
                          >
                            <div class="d-flex align-items-center">
                              <b-form-input
                                v-model="seller"
                                class="input__radius"
                                disabled
                              />
                            </div>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>


                        <b-form-group :label="$t('buyer')" class="">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('buyer')"
                            rules="required"
                          >
                            <div class="d-flex align-items-center">
                              <b-form-input
                                v-model="buyer"
                                class="input__radius"
                                disabled
                              />
                            </div>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <!--  ==============================  FILTERS_SECTION END ============================== -->





                      </div>
                      <div class="d-flex">
                        <b-button
                          v-if="checkButtonPermission(['supplier', 'chief_supplier', 'accountant', 'chief_manager', 'admin'])"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          size="sm"
                          class="d-flex align-items-center ml-50"
                          variant="success"
                          @click="showModalAddFiles()"
                          :disabled="!isMounted"
                        >
                          <feather-icon
                            icon="EyeIcon"
                            size="18"
                            class="mr-50"
                          />
                          {{$t('watch_files')}}
                        </b-button>
                      </div>
                    </div>
                  </div>

                  <hr class="mt-3 mb-2" />
                  <b-row>
                    <b-col class="col-md-12 text-center mb-1">
                      <h2>{{ $t("based_on_applications") }}</h2>
                    </b-col>
                    <b-col cols="12">


                      <!--  ==============================  BASED_ON_APPLICATION_TABLE START ============================== -->
                      <BasedOnAplication />
                      <!--  ==============================  BASED_ON_APPLICATION_TABLE END ============================== -->


                    </b-col>
                  </b-row>

                  <b-row class="treaty mt-2">
                    <b-col md="12" class="mb-2 text-center">
                      <h2>{{ $t("subject_of_the_contract") }}</h2>
                    </b-col>

                    <b-col class="col-md-12 mb-3">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h4 class="mb-0">
                          {{ $t("reference.material") }}
                        </h4>
                      </div>


                      <!--  ==============================  MATERIALS_TABLE START ============================== -->
                      <MaterialsTable />
                      <!--  ==============================  MATERIALS_TABLE END ============================== -->


                    </b-col>
                    <b-col class="col-md-12 mb-2">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h4 class="mb-0">
                          {{ $t("reference.instrument") }}
                        </h4>
                      </div>


                      <!--  ==============================  INSTRUMENTS_TABLE START ============================== -->
                      <InstrumentsTable />
                      <!--  ==============================  INSTRUMENTS_TABLE END ============================== -->


                    </b-col>
                  </b-row>

                  <b-row class="sum mt-2">
                    <b-col class="col-md-12 text-center mb-1">
                      <h2>{{ $t("аmount_of_contract_and_invoice") }}</h2>
                    </b-col>
                    <b-col md="2">
                      <span
                        >{{ $t("total_amount") }}:&nbsp;{{
                          $_formatPriceMixin(contract.total_sum)
                        }}</span
                      >
                    </b-col>
                  </b-row>

                  <hr class="mt-1" />

                  <div class="text-right mt-3">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      class="d-flex align-items-center"
                      variant="primary"
                      @click="$router.back()"
                    >
                      <feather-icon icon="ArrowLeftIcon" size="18" />
                      {{ $t("back") }}
                    </b-button>
                  </div>
                </b-tab>
                <!--  ==============================  AGREEMENT_SECTION END ============================== -->









                <!--  ==============================  INVOICES_SECTION START ============================== -->
                <b-tab
                  v-if="
                    GET_ONE_CONTRACT &&
                    GET_ONE_CONTRACT.status &&
                    (GET_ONE_CONTRACT.status.unique_name == 'paid_contract'
                    || GET_ONE_CONTRACT.status.unique_name == 'close_contract')
                  "
                  :title="$t('invoices')"
                >
                  <b-row class="treaty">
                    <b-col class="col-md-12 mb-3">
                      <InvoicesTable />
                    </b-col>
                  </b-row>
                </b-tab>
                <!--  ==============================  INVOICES_SECTION START ============================== -->







              </b-tabs>
            </validation-observer>



            <!--  ==============================  MODALS_SECTION START ============================== -->
            <AddContractInvoiceModal
              @refreshPage="refresh()"
            ></AddContractInvoiceModal>
            <SuppliersModal @input="companyInput" />
            <BuyersModal @input="buyerCompanyInput" />
            <modalUniversal :type="type" />
            <!--  ==============================  MODALS_SECTION START ============================== -->





          </b-card>
        </b-col>

        <b-col cols="3">
          <b-card>
            <div class="d-flex flex-wrap">




              <!--  ==============================  TIMELINE_SECTION START ============================== -->
              <app-timeline class="h-100 w-100">
                <app-timeline-item
                  v-for="item in GET_APPLICATION_STATUS_TIMELINE_BY_ID"
                  :key="item.id"
                  :title="item.to_status.full_name + ' #' + item.object_id"
                  :subtitle="item.author.first_name + item.author.last_name"
                  :comment="(item.description ? item.description : '')"
                  :icon="item.to_status.icon"
                  :time="$dayjs(item.created_at).format('DD.MM.YYYY, HH:mm')"
                  :variant="item.to_status.color"
                  :author="true"
                >
                </app-timeline-item>
              </app-timeline>
              <!--  ==============================  TIMELINE_SECTION START ============================== -->




            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <addFilesModal1 :type="addFilestype"/>





    <!--  ==============================  MODALS_SECTION START ============================== -->
    <b-modal
      ref="confirmOrRefuse2"
      cancel-variant="outline-secondary"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @cancel="clearInput()"
      @close="clearInput()"
      centered
      size="md"
      no-close-on-backdrop
      :title="statusDeniedOrWaiting == 'denied_contract' ? $t('do_you_really_want') + ' ' + $t('switch_to_denied_status') 
      : statusDeniedOrWaiting == 'awaiting_contract' ? $t('do_you_really_want') + ' ' + $t('switch_to_pending_payment_status')
      : $t('do_you_really_want') + ' ' + $t('submit_this_application_for_financiers_review')"
      @ok="onStatusChangedAndSaved($event)"
    >
      <div>
        <validation-observer ref="confirmOrRefuseObserver">
          <b-form-group :label="$t('contact.comment')">
            <validation-provider
              #default="{ errors }"
              :name="$t('contact.comment')"
              rules="required"
            >
              <b-form-textarea
                v-model="statusComment"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </div>
    </b-modal>
    <!--  ==============================  MODALS_SECTION START ============================== -->

    


  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BRow,
  BCol,
  BButton,
  BCard,
  BTabs,
  BTab,
  BBadge,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Ripple from "vue-ripple-directive";

import MaterialsTable from "./components/tables/materialsTable.vue";
import InstrumentsTable from "./components/tables/instrumentsTable.vue";
import InvoicesTable from "./components/tables/invoicesTable.vue";

import BasedOnAplication from "./components/tables/BasedOnAplication.vue";

import SuppliersModal from "./components/modals/suppliersModal.vue";
import BuyersModal from "./components/modals/buyersModal.vue";

import modalUniversal from "./components/modals/modalMaterialInstrument.vue";
import AddContractInvoiceModal from "./components/modals/addContractInvoiceModal.vue";

import VueDataPicker from "@/components/VueDatePicker.vue";
import objective from "@/mixins/objective";
import check from "@/mixins/check";
import loader from "@/mixins/loader";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import addFilesModal1 from './components/modals/addFilesModal1.vue'

import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BCard,
    BTabs,
    BTab,
    BBadge,

    MaterialsTable,
    InstrumentsTable,
    InvoicesTable,
    SuppliersModal,
    BuyersModal,

    VueDataPicker,

    modalUniversal,
    BasedOnAplication,
    AddContractInvoiceModal,

    ValidationObserver,
    ValidationProvider,

    addFilesModal1,

    AppTimeline,
    AppTimelineItem,
  },
  directives: {
    Ripple,
  },
  mixins: [objective, check, loader, priceFormatMixin],
  data() {
    return {



      // =============== PRIMARY_DATA START ===============
      type: true,
      seller: null,
      buyer: null,
      addFilestype: 'add',
      isMounted: false,
      statusDeniedOrWaiting: '',
      statusComment: '',
      statusId: ''
      // =============== PRIMARY_DATA END ===============




    };
  },
  computed: {
    ...mapGetters("agrements", ["GET_ONE_CONTRACT"]),
    ...mapState("agrements", ["materialAndInstrumentApplications"]),
    ...mapGetters("application", [
      "GET_APPLICATION_STATUS_TIMELINE_BY_ID",
    ]),




    // ========================= SETTERS_AND_GETTERS START =========================
    contract: {
      get: function () {
        return this.$store.state.agrements.contract;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_CONTRACT", newValue);
      },
    },
    materialItems: {
      get: function () {
        return this.$store.state.agrements.materialItems;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_MATERIAL_ITEMS", newValue);
      },
    },
    instrumentItems: {
      get: function () {
        return this.$store.state.agrements.instrumentItems;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_INSTRUMENT_ITEMS", newValue);
      },
    },
    invoiceItems: {
      get: function () {
        return this.$store.state.agrements.invoiceItems;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_INVOICE_ITEMS", newValue);
      },
    },
    materialAndInstrumentApplications: {
      get: function () {
        return this.$store.state.agrements.materialAndInstrumentApplications;
      },
      set: function (newValue) {
        this.$store.commit(
          "agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS",
          newValue
        );
      },
    },
    viewMode: {
      get: function () {
        return this.$store.state.agrements.viewMode;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_VIEW_MODE", newValue);
      },
    },
    refreshAgreement: {
      get: function () {
        return this.$store.state.agrements.refreshAgreement;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_REFRESH_AGREEMENT", newValue);
      },
    },
    contractFiles: {
      get: function () {
        return this.$store.state.agrements.contractFiles;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_CONTRACT_FILES', newValue)
      }
    },
    // ========================= SETTERS_AND_GETTERS END =========================



  },
  watch: {





    // ========================= CALCULATE_SUM_WATCHERS START =========================
    materialItems: {
      deep: true,
      handler(newValue) {
        // this.calculateSum();
      },
    },
    instrumentItems: {
      deep: true,
      handler(newValue) {
        // this.calculateSum();
      },
    },
    async refreshAgreement(newValue) {
      if (newValue) {
        await this.refresh();
        this.refreshAgreement = false;
      }
    },

    materialAndInstrumentApplications: {
      deep: true,
      handler(newValue) {
        if ((!this.viewMode) || this.$route.params.id === "new") {
          let materials = [];
          let instruments = [];
          let goodsCheckExist = [];
          let goodsCheckNotExist = [];
          let instrumentsCheckExist = [];
          let instrumentsCheckNotExist = [];

          

          
          newValue.forEach((elem) => {
            if (elem.goods) {
              let withID = [];

              let goodsNew = elem.goods.map((item) => ({
                requirement_id: elem.id ? elem.id : null,
                id: null,
                product: item?.good?.product?.title,
                good: item.good,
                count: item.count,
                responsible: item.responsible,
                price: item.price,
                // object: elem.storage
              }));

              withID = this.materialItems.filter((item2) =>
                item2.hasOwnProperty("id")
              );

              goodsNew.forEach((item1) => {
                if (withID.length != 0) {
                  goodsCheckExist = withID.find((item2) => {
                    if (item1.id == item2.id) {
                      return item2;
                    }
                  });

                  if (!goodsCheckExist) {
                    materials.push(item1);
                  }
                } else {
                  materials.push(item1);
                }
              });
            }else if (elem.instruments) {
              let withID = [];

              let instrumentsNew = elem.instruments.map((item) => ({
                requirement_id: elem.id ? elem.id : null,
                id: null,
                product: item.instrument.type.title,
                instrument: item.instrument,
                count: item.count,
                responsible: item.responsible,
                price: item.price,
                // object: elem.storage
              }));

              withID = this.instrumentItems.filter((item2) =>
                item2.hasOwnProperty("id")
              );
              

              instrumentsNew.forEach((item1) => {
                if (withID.length != 0) {
                  instrumentsCheckExist = withID.find((item2) => {
                    if (item1.id == item2.id) {
                      return item2;
                    }
                  });

                  if (!instrumentsCheckExist) {
                    instruments.push(item1);
                  }
                } else {
                  instruments.push(item1);
                }
              });
            }
          });

          this.materialItems = this.materialItems.concat(materials);
          this.instrumentItems = this.instrumentItems.concat(instruments);

          this.materialItems = this.materialItems.filter((elem) => elem.count != 0);
          this.instrumentItems = this.instrumentItems.filter((elem) => elem.count != 0);
        }
      },
    },
    // ========================= CALCULATE_SUM_WATCHERS END =========================





  },
  async created(){





    // ========================= PRIMARY_INITIALIZATION START =========================
    this.contract.type_contract = true
    this.contract.contract_number = null
    this.contract.seller = null
    this.contract.buyer = null
    this.contract.goods = []
    this.contract.instrument = []
    this.contract.date = null
    this.contract.total_sum = null
    
    this.seller = null
    this.buyer = null
    this.addFilestype = 'add',
    this.type = true

    this.materialAndInstrumentApplications = []
    this.materialItems = []
    this.instrumentItems = []
    this.contractFiles = []
    // ========================= PRIMARY_INITIALIZATION END =========================





  },
  async mounted() {
    await this.$_loaderStart();




    // ========================= VIEW_AND_EDIT_MODES START =========================
    if (this.$route.name == 'view-agreements') {
      this.viewMode = true;
    }

    await this.refresh();
    await this.refreshTimeline()

    this.isMounted = true
    // ========================= VIEW_AND_EDIT_MODES END =========================





  },
  async beforeRouteLeave(to, from, next) {
    await this.$_loaderStop();
    next();
  },
  methods: {
    ...mapActions("agrements", [
      "UPDATE_PATCH_CONTRACTS_LIST",
      "FETCH_ONE_CONTRACTS",
    ]),
    ...mapActions("application", [
      "FETCH_APPLICATION_STATUS_TIMELINE_BY_ID",
    ]),





    // =============== REFRESH_TIMELINE START ===============
    async refreshTimeline() {
      await this.FETCH_APPLICATION_STATUS_TIMELINE_BY_ID({
        id: this.$route.params.id,
        params: {
          content_type_model: "contracts",
          object_id: this.$route.params.id,
        },
      });
    },
    // =============== REFRESH_TIMELINE END ===============
    
    







    // ========================= REFRESH START =========================
    async refresh() {
        await this.FETCH_ONE_CONTRACTS(this.$route.params.id)
          .then(() => {
            const {
              id,
              contract_number,
              amount,
              seller,
              buyer,
              files,
              instruments,
              goods,
              invoice,
              created_at,
              requirement_goods,
              requirement_instruments,
              // eslint-disable-next-line no-unused-vars
            } = this.GET_ONE_CONTRACT;
            
            this.contract = {
              id,
              contract_number,
              total_sum: amount,
              seller: seller?.id,
              buyer: buyer?.id,
              date: created_at,
            };

            
            this.materialItems = goods.map((item) => ({
              requirement_id: item.requirement_id ? item.requirement_id : null,
              id: item.id,
              product: item.good?.product?.title,
              good: item.good,
              count: this.$_formatPriceMixin(item.count),
              responsible: item.responsible,
              price: this.$_formatPriceMixin(item.price),
            }));
            
            

            this.instrumentItems = instruments.map((item) => ({
              requirement_id: item.requirement_id ? item.requirement_id : null,
              id: item.id,
              product: item.instrument?.type?.title,
              instrument: item.instrument,
              count: this.$_formatPriceMixin(item.count),
              responsible: item.responsible,
              price: this.$_formatPriceMixin(item.price),
            }));

            this.invoiceItems = invoice;
            this.contractFiles = files;

            this.invoiceItems.forEach((elem) => {
              elem.goods.forEach((item) => {
                item.count = this.$_formatPriceMixin(item.quantity);
              });
              elem.instruments.forEach((item) => {
                item.count = this.$_formatPriceMixin(item.quantity);
              });
            });

            this.materialAndInstrumentApplications = requirement_goods.concat(requirement_instruments);

            this.seller = seller.company_name;
            this.buyer = buyer.company_name;
          })
          .catch((err) => {
            console.log(err)
            if (
              err &&
              err.response &&
              err.response.status &&
              err.response.status == 404
            ) {
              this.$router.push("/agreements");
            }
          });
    },
    
    
    
    
    
    async refreshPage(event) {
      await this.refresh();
      await this.refreshTimeline()
    },
    // ========================= REFRESH END =========================




















    // ===============  SEARCH_SECTION START ===============
    formatPrice(value, type) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);

        if (type == "total_sum") {
          this.contract.total_sum = currency;
        } else if (type == "currency") {
          return currency;
        }
      }
      return 0;
    },
    // ===============  SEARCH_SECTION END ===============














    // ========================= CALCULATE_SUM START =========================
    calculateSum() {
      this.$set(this.contract, "total_sum", 0);
      this.materialItems.forEach((item) => {
        item.count = this.formatPrice(item.count, "currency");
        item.price = this.formatPrice(item.price, "currency");
        if (item.count && item.price) {
          this.contract.total_sum +=
            item.count.toString().replace(/,/g, "") *
            item.price.toString().replace(/,/g, "");
        }
      });
      this.instrumentItems.forEach((item) => {
        item.count = this.formatPrice(item.count, "currency");
        item.price = this.formatPrice(item.price, "currency");
        if (item.count && item.price) {
          this.contract.total_sum +=
            item.count.toString().replace(/,/g, "") *
            item.price.toString().replace(/,/g, "");
        }
      });

      this.formatPrice(this.contract.total_sum, "total_sum");
    },
    // ========================= CALCULATE_SUM END =========================










    // =============== DISABLE_STATUS_IF_NEEDED START ===============
    disableStatusIfNeeded() {
      let status = true;
      let countNeeded = 0;
      let countExist = 0;

      if (this.GET_ONE_CONTRACT.status.unique_name != "paid_contract") {
        status = false;
      }

      this.GET_ONE_CONTRACT.goods.forEach((elem) => {
        countNeeded = countNeeded + elem.count;
      });
      this.GET_ONE_CONTRACT.instruments.forEach((elem) => {
        countNeeded = countNeeded + elem.count;
      });

      this.GET_ONE_CONTRACT.invoice.forEach((elem) => {
        if (elem.status.unique_name == "accepted_invoice") {
          elem.goods.forEach((item) => {
            countExist = countExist + item.quantity;
          });
          elem.instruments.forEach((item) => {
            countExist = countExist + item.quantity;
          });
        }
      });

      if (countExist == countNeeded) {
        status = false;
      }

      return status;
    },
    // =============== DISABLE_STATUS_IF_NEEDED END ===============














    // ========================= SHOW_MODALS START =========================
    showModalAddFiles(id){
      this.addFilestype = 'show'
      this.$bvModal.show('addFilesModal1')
    },
    // ========================= SHOW_MODALS END =========================
















    // ========================= OTHERS START =========================
    companyInput(e) {
      this.seller = e.company_name;
      this.$set(this.contract, "seller", e.id);
    },
    buyerCompanyInput(e) {
      this.buyer = e.company_name;
      this.$set(this.contract, "buyer", e.id);
    },
    async onStatusChangedAndSaved(bvModalEvt){
      bvModalEvt.preventDefault();
      await this.$refs.confirmOrRefuseObserver.validate().then(async (success) => {
        if (!success) return;
        await this.UPDATE_PATCH_CONTRACTS_LIST({
          data: {
            status_unique: this.statusDeniedOrWaiting,
            status_description: this.statusComment,
            id: this.statusId,
          },
          id: this.statusId,
        }).then(() => {
          this.$refs.confirmOrRefuse2.hide();
          this.refreshPage();
          this.statusComment = ''
          this.$_okToast("success");
        });
      })
        
    },
    clearInput(){
      this.statusComment = ''
    },
    onChangeStatus(props, item) {
      const status = {
        denied_contract: this.$t("switch_to_denied_status"),
        paid_contract: this.$t("switch_to_paid_status"),
        awaiting_contract: this.$t("switch_to_pending_payment_status"),
        close_contract: this.$t("go_to_completed_status"),
        in_consideration_contract: this.$t("submit_this_application_for_review"),
        in_supervisors_consideration_contract: this.$t("submit_this_application_for_supervisors_review"),
        in_financiers_consideration_contract: this.$t("submit_this_application_for_financiers_review"),
      };

      this.statusId = props.id
      if(item.unique_name == 'denied_contract'){
        this.$refs['confirmOrRefuse2'].show()
        this.statusDeniedOrWaiting = 'denied_contract'
      }else if(item.unique_name == 'awaiting_contract'){
        this.$refs['confirmOrRefuse2'].show()
        this.statusDeniedOrWaiting = 'awaiting_contract'
      }else if(item.unique_name == 'in_financiers_consideration_contract'){
        this.$refs['confirmOrRefuse2'].show()
        this.statusDeniedOrWaiting = 'in_financiers_consideration_contract'
      }else{
        this.$bvModal
          .msgBoxConfirm(
            this.$t("do_you_really_want") + ` ${status[item.unique_name]} ?`,
            {
              title: this.$i18n.t("attention"),
              size: "sm",
              okVariant: item.color,
              okTitle: this.$t("yes"),
              cancelTitle: this.$t("no"),
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then(async (value) => {
            if (!value) return;
            this.UPDATE_PATCH_CONTRACTS_LIST({
              data: {
                status_unique: item.unique_name,
                id: props.id,
              },
              id: props.id,
            }).then(() => {
              this.refreshPage();
              this.$_okToast("success");
            });
          });
      }
    },
    // ========================= OTHERS END =========================










  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.dark-layout .date-dark input {
  background-color: #283046 !important;
}

.repeater-form {
  transition: 0.35s height;
}

.choose-btn {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  display: flex;
  align-items: center;
}

.input__radius {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  min-width: 300px;
}
</style>
